/**
 * REGISTRATION CHANNEL — the `canal` URL parameter, as V1 handles it.
 *
 * V1 (`appRouter.jsx`) stores `?canal=xxxx` in `localStorage` on any page it lands on,
 * then writes it as `registeredFrom` with the registration (`|| 'WEB'` when absent).
 * Same here: the stored value survives the navigation to the sign-up and the steps.
 */
const KEY = "canal";
const DEFAULT_CHANNEL = "WEB";

/** Keeps `canal` from the query string, if present. A new value replaces the old one. */
export function captureChannel(search: string): void {
  const canal = new URLSearchParams(search).get("canal");
  if (!canal) return;
  try {
    localStorage.setItem(KEY, canal);
  } catch {
    /* storage unavailable: the registration falls back to the default channel */
  }
}

/** The value written as `registeredFrom`. */
export function registrationChannel(): string {
  try {
    return localStorage.getItem(KEY) || DEFAULT_CHANNEL;
  } catch {
    return DEFAULT_CHANNEL;
  }
}
